import { Link, TrackingData } from '@ecm/router';

import { Bundle } from '../../../api/dashboard/item/itemSection/consoFamily/bundle';
import { BundleCodeEnum } from '../../../api/dashboard/item/itemSection/consoFamily/bundleCodeEnum';
import { BundleSummary } from '../../../api/dashboard/item/itemSection/consoFamily/bundleSummary';
import { ConsoFamilyEnum } from '../../../api/dashboard/item/itemSection/consoFamily/consoFamilyEnum';
import { Equipment } from '../../../api/dashboard/item/itemSection/equipment';
import { ItemSection } from '../../../api/dashboard/item/itemSection/itemSection';
import { UsageCodeEnum } from '../../../api/dashboard/item/itemSection/usageCodeEnum';
import { PushSubItemViewModel } from '../../../model/home/pushSubItem.view-model';
import { SubItemViewModel } from '../../../model/home/subItem.view-model';
import { SubItemTypeEnum } from '../../../model/home/subItemTypeEnum';
import { TmsCodes } from '../../../model/tracking/tmsCodes.enum';
import { TrackedName } from '../../../model/tracking/trackedName.enum';
import { TrackedPage } from '../../../model/tracking/trackedPage.enum';
import { DashboardV7MapperUtils } from '../dashboard/dashboardV7-utils.mapper';

export class DeviceSimMapper {
    public static extractSubItemSim(
        itemSection: ItemSection,
        cid: string,
        dashboardTranslations: any,
    ): SubItemViewModel[] | null {
        const suiviConso = 'suivi_conso';
        const subItemsViewModel: SubItemViewModel[] = [];
        if (Object.prototype.hasOwnProperty.call(itemSection, 'consoFamilies')) {
            let showNoExtraBalance = false;
            let freeBies = false;
            let freeBiesLabel: string;
            // browse array to identify when "hors forfait = 0,00" or when "Bonus : reste 3,OO"
            for (const consoFamily of itemSection.consoFamilies) {
                if (
                    !showNoExtraBalance &&
                    Object.prototype.hasOwnProperty.call(consoFamily, 'bundle') &&
                    consoFamily.bundle.bundleCode === BundleCodeEnum.horsForfait &&
                    !consoFamily.bundle.summary.displayAlertIcon
                ) {
                    showNoExtraBalance = true;
                }
                if (
                    !freeBies &&
                    Object.prototype.hasOwnProperty.call(consoFamily, 'bundle') &&
                    consoFamily.familyCode === ConsoFamilyEnum.credit_2 &&
                    (consoFamily.bundle.bundleCode === BundleCodeEnum.EPUISE ||
                        consoFamily.bundle.bundleCode === BundleCodeEnum.SOLDE) &&
                    consoFamily.bundle.summary.usageText
                ) {
                    freeBies = true;
                    freeBiesLabel =
                        consoFamily.bundle.bundleCode === BundleCodeEnum.EPUISE
                            ? dashboardTranslations['deviceSIM']['internetMobile']['exhaustedFreeBies']
                            : dashboardTranslations['deviceSIM']['internetMobile']['freeBies'].concat(
                                  DashboardV7MapperUtils.convertMainCredit(
                                      consoFamily.bundle.summary.mainCredit.value,
                                      consoFamily.bundle.summary.mainCredit.unit,
                                  ),
                              );
                }
            }
            for (const consoFamily of itemSection.consoFamilies) {
                const subItem: SubItemViewModel = new SubItemViewModel();
                subItem.detail = [];
                subItem.detailLong = [];
                subItem.cid = cid;
                subItem.type = SubItemTypeEnum.picto;
                subItem.bundleCode = consoFamily?.bundle?.bundleCode;
                subItem.trackingData = Object.assign(new TrackingData(), {
                    tmsTracking: {
                        trackedPage: TrackedPage.dashboard,
                        trackingArea: TmsCodes.care_hp_mobile,
                    },
                });

                // manage gauge and details

                if (Object.prototype.hasOwnProperty.call(consoFamily, 'bundle')) {
                    const bundle: Bundle = consoFamily.bundle;
                    const summary: BundleSummary = bundle.summary;
                    if (consoFamily.familyCode === ConsoFamilyEnum.error) {
                        subItem.label = dashboardTranslations['deviceSIM']['internetMobile']['consumption'];
                        subItem.consumption = dashboardTranslations['deviceSIM']['error']['consumption'];
                        subItem.picto = dashboardTranslations['picto']['GAUGE_RESEAU'];
                        subItem.trackingData.tmsTracking.trackingName = suiviConso;

                        subItem.link = DashboardV7MapperUtils.getConsoPath(
                            cid,
                            itemSection.idSuiviConso,
                            dashboardTranslations,
                            itemSection.equipmentId,
                        );
                        /* subItem.picto = dashboardTranslations['picto']['DEFAULT_CONSO']; */
                    } else if (consoFamily.familyCode === ConsoFamilyEnum.credit_2) {
                        continue;
                    } else if (
                        consoFamily.familyCode === ConsoFamilyEnum.credit ||
                        consoFamily.familyCode === ConsoFamilyEnum.compteRechargeable
                    ) {
                        subItem.type = SubItemTypeEnum.picto;
                        if (consoFamily.familyCode === ConsoFamilyEnum.credit) {
                            if (summary.mainCredit) {
                                subItem.consumption = dashboardTranslations['deviceSIM']['internetMobile'][
                                    'prePaidRestText'
                                ].concat(
                                    DashboardV7MapperUtils.convertMainCredit(
                                        summary.mainCredit.value,
                                        summary.mainCredit.unit,
                                    ) + ' €',
                                );
                            } else {
                                subItem.consumption =
                                    dashboardTranslations['deviceSIM']['internetMobile']['prePaidExhaustedText'];
                                subItem.alert = true;
                            }
                            if (freeBies) {
                                subItem.freeBies = freeBiesLabel;
                            }
                        }

                        if (consoFamily.familyCode === ConsoFamilyEnum.compteRechargeable) {
                            if (summary.mainCredit) {
                                subItem.consumption = dashboardTranslations['deviceSIM']['internetMobile'][
                                    'topUp'
                                ].concat(
                                    dashboardTranslations['deviceSIM']['internetMobile']['restText'].concat(
                                        DashboardV7MapperUtils.convertMainCredit(
                                            summary.mainCredit.value,
                                            summary.mainCredit.unit,
                                        ) + ' €',
                                    ),
                                );
                            } else {
                                subItem.consumption =
                                    dashboardTranslations['deviceSIM']['internetMobile']['exhaustedText'];
                                subItem.alert = true;
                            }
                        }
                        subItem.label = dashboardTranslations['deviceSIM']['internetMobile']['consumption'];
                        subItem.picto = dashboardTranslations['picto']['GAUGE_RESEAU'];
                        subItem.link = DashboardV7MapperUtils.getConsoPath(
                            cid,
                            itemSection.idSuiviConso,
                            dashboardTranslations,
                            itemSection.equipmentId,
                        );
                        subItem.trackingData.tmsTracking.trackingName = suiviConso;
                    } else {
                        if (Object.prototype.hasOwnProperty.call(bundle, 'gaugeInfo') && summary.displayGauge) {
                            subItem.type = SubItemTypeEnum.gauge;
                            subItem.gaugePercent = bundle.gaugeInfo.percent;
                            subItem.totalData = bundle.gaugeInfo.to;
                            subItem.consumption = dashboardTranslations['deviceSIM']['internetMobile'][
                                'restText'
                            ].concat(
                                summary.mainCredit
                                    ? DashboardV7MapperUtils.convertMainCredit(
                                          summary.mainCredit.value,
                                          summary.mainCredit.unit,
                                      )
                                    : '',
                            );
                            subItem.label = dashboardTranslations['deviceSIM']['internetMobile']['consumption'];
                            subItem.picto = dashboardTranslations['picto']['GAUGE_RESEAU'];
                            subItem.link = DashboardV7MapperUtils.getConsoPath(
                                cid,
                                itemSection.idSuiviConso,
                                dashboardTranslations,
                                itemSection.equipmentId,
                            );
                            subItem.trackingData.tmsTracking.trackingName = suiviConso;
                            if (showNoExtraBalance) {
                                subItem.noExtraBalance =
                                    dashboardTranslations['deviceSIM']['extraBalance']['restTextNull'];
                            }
                        }

                        if (bundle.bundleCode === BundleCodeEnum.horsForfait) {
                            if (!summary.displayAlertIcon) {
                                continue;
                            } else {
                                subItem.label = dashboardTranslations['deviceSIM']['extraBalance']['restText'].concat(
                                    summary.mainCredit
                                        ? DashboardV7MapperUtils.convertMainCredit(
                                              summary.mainCredit.value,
                                              summary.mainCredit.unit,
                                          ) + ' €'
                                        : '',
                                );
                                subItem.alert = true;
                                subItem.detail.push(dashboardTranslations['deviceSIM']['extraBalance']['consumption']);
                                subItem.detailLong.push(
                                    dashboardTranslations['deviceSIM']['extraBalance']['consumption'],
                                );

                                subItem.trackingData.tmsTracking.trackingName = 'hors_forfait';
                            }
                        } else if (!summary.displayGauge) {
                            subItem.type = SubItemTypeEnum.picto;
                            subItem.alert = true;
                            subItem.link = DashboardV7MapperUtils.getConsoPath(
                                cid,
                                itemSection.idSuiviConso,
                                dashboardTranslations,
                                itemSection.equipmentId,
                            );
                            subItem.label = dashboardTranslations['deviceSIM']['internetMobile']['consumption'];
                            if (consoFamily.familyCode === ConsoFamilyEnum.internetMobile) {
                                let consumption: string;
                                switch (bundle.bundleCode) {
                                    case BundleCodeEnum.LIBI:
                                        consumption = 'internetUnlimitedText';
                                        subItem.alert = false;
                                        break;
                                    case BundleCodeEnum.SeuilAtteint:
                                        consumption = 'internetReducedText';
                                        break;
                                    default:
                                        consumption = 'internetExhaustedText';
                                        break;
                                }

                                subItem.consumption = dashboardTranslations['deviceSIM']['internetMobile'][consumption];
                            } else {
                                subItem.consumption =
                                    dashboardTranslations['deviceSIM']['internetMobile']['exhaustedText'];
                            }
                            subItem.trackingData.tmsTracking.trackingName = suiviConso;
                            subItem.picto = dashboardTranslations['picto']['GAUGE_RESEAU'];
                            if (showNoExtraBalance) {
                                subItem.noExtraBalance =
                                    dashboardTranslations['deviceSIM']['extraBalance']['restTextNull'];
                            }
                        }
                    }
                }

                subItemsViewModel.push(subItem);
            }
        }
        if (Object.prototype.hasOwnProperty.call(itemSection, 'equipments')) {
            for (const equipment of itemSection.equipments) {
                subItemsViewModel.push(this.getEquipment(equipment, dashboardTranslations));
            }
        }
        if (Object.prototype.hasOwnProperty.call(itemSection, 'service24')) {
            subItemsViewModel.push(this.getService24(itemSection, dashboardTranslations));
        }
        if (Object.prototype.hasOwnProperty.call(itemSection, 'recoOffer')) {
            subItemsViewModel.push(
                DashboardV7MapperUtils.extractZid(
                    'recoMobileOffer',
                    DashboardV7MapperUtils.getCommercialInfo(itemSection.recoOffer),
                ),
            );
        }

        if (Object.prototype.hasOwnProperty.call(itemSection, 'recoMobileRenewal')) {
            subItemsViewModel.push(
                DashboardV7MapperUtils.extractZid(
                    'recoMobileRenewal',
                    DashboardV7MapperUtils.getCommercialInfo(itemSection.recoMobileRenewal),
                ),
            );
        }

        if (Object.prototype.hasOwnProperty.call(itemSection, 'reco')) {
            const pushSubItem: PushSubItemViewModel = DashboardV7MapperUtils.getCommercialInfo(itemSection.reco, true);
            pushSubItem.label = itemSection.reco.content;
            pushSubItem.detail = null;
            subItemsViewModel.push(DashboardV7MapperUtils.extractZid('recoMobile', pushSubItem));
        }

        if (subItemsViewModel.length <= 1) {
            return subItemsViewModel;
        }
        const index = subItemsViewModel.findIndex(
            (subItem) => subItem.bundleCode === BundleCodeEnum.horsForfait && subItem.type === 'picto',
        );

        if (index === -1) {
            return subItemsViewModel;
        }

        const extraBalance = subItemsViewModel[index].label;

        subItemsViewModel.forEach((item) => {
            if (item.type !== 'picto') {
                item.noExtraBalance = extraBalance;
            }
        });

        subItemsViewModel.splice(index, 1);
        return subItemsViewModel;
    }

    public static extractSubItemFixe(
        itemSection: ItemSection,
        cid: string,
        dashboardTranslations: any,
    ): SubItemViewModel[] | null {
        const suiviConso = 'suivi_conso';
        const subItemsViewModel: SubItemViewModel[] = [];
        if (Object.prototype.hasOwnProperty.call(itemSection, 'consoFamilies')) {
            for (const consoFamily of itemSection.consoFamilies) {
                const subItem: SubItemViewModel = new SubItemViewModel();
                subItem.detail = [];
                subItem.detailLong = [];
                subItem.cid = cid;
                subItem.trackingData = Object.assign(new TrackingData(), {
                    tmsTracking: {
                        trackedPage: TrackedPage.dashboard,
                        trackingArea: TmsCodes.care_hp_mobile,
                    },
                });
                subItem.type = SubItemTypeEnum.picto;
                // manage gauge and details

                if (Object.prototype.hasOwnProperty.call(consoFamily, 'bundle')) {
                    const bundle: Bundle = consoFamily.bundle;
                    const summary: BundleSummary = bundle.summary;
                    subItem.label = dashboardTranslations['deviceHome']['consumption'];
                    if (consoFamily.familyCode === ConsoFamilyEnum.error) {
                        subItem.consumption = dashboardTranslations['deviceHome']['error'];
                        subItem.trackingData.tmsTracking.trackingName = suiviConso;
                        subItem.picto = dashboardTranslations['picto']['GAUGE_RESEAU'];
                        subItem.link = DashboardV7MapperUtils.getConsoPathFixe(
                            cid,
                            itemSection.equipmentId,
                            dashboardTranslations,
                        );
                        /* subItem.picto = dashboardTranslations['picto']['DEFAULT_CONSO']; */
                    } else if (consoFamily.familyCode === ConsoFamilyEnum.credit) {
                        subItem.type = SubItemTypeEnum.picto;
                        subItem.picto = dashboardTranslations['picto']['GAUGE_RESEAU'];
                        subItem.link = DashboardV7MapperUtils.getConsoPathFixe(
                            cid,
                            itemSection.equipmentId,
                            dashboardTranslations,
                        );

                        subItem.consumption = dashboardTranslations['deviceHome']['restTextConsumption'].concat(
                            summary.mainCredit
                                ? DashboardV7MapperUtils.convertMainCredit(
                                      summary.mainCredit.value,
                                      summary.mainCredit.unit,
                                  )
                                : ' €',
                        );
                        if (bundle.bundleCode === BundleCodeEnum.EPUISE) {
                            //subItem.type = SubItemTypeEnum.picto;
                            subItem.consumption = dashboardTranslations['deviceHome']['exhaustedText'];
                            subItem.picto = dashboardTranslations['picto']['GAUGE_RESEAU'];
                        }
                    } else if (consoFamily.familyCode === ConsoFamilyEnum.communicationsPayantes) {
                        subItem.type = SubItemTypeEnum.picto;
                        if (bundle.summary.mainCredit.value > 0) {
                            subItem.consumption = dashboardTranslations['deviceHome']['cosnumptionText'].concat(
                                DashboardV7MapperUtils.convertMainCredit(
                                    summary.mainCredit.value,
                                    summary.mainCredit.unit,
                                ) + ' €',
                            );
                            subItem.picto = dashboardTranslations['picto']['GAUGE_RESEAU'];
                        } else if (bundle.summary.mainCredit.value === 0) {
                            subItem.consumption = dashboardTranslations['deviceHome']['cosnumptionText'].concat(
                                DashboardV7MapperUtils.convertMainCredit(
                                    summary.mainCredit.value,
                                    summary.mainCredit.unit,
                                ) + ' €',
                            );
                        } else if (bundle.bundleCode === BundleCodeEnum.EPUISE) {
                            subItem.consumption = dashboardTranslations['deviceHome']['exhaustedText'];
                            subItem.picto = dashboardTranslations['picto']['GAUGE_RESEAU'];
                        }

                        /*  subItem.label = dashboardTranslations['deviceHome']['consumption']; */
                        subItem.link = DashboardV7MapperUtils.getConsoPathFixe(
                            cid,
                            itemSection.equipmentId,
                            dashboardTranslations,
                        );
                    }
                    subItem.trackingData.tmsTracking.trackingName = suiviConso;
                    subItemsViewModel.push(subItem);
                }
            }
        }

        return subItemsViewModel;
    }

    private static getEquipment(equipment: Equipment, translation: any): SubItemViewModel {
        const subItem: SubItemViewModel = new SubItemViewModel();
        subItem.type = SubItemTypeEnum.picto;
        subItem.trackingArea = TmsCodes.care_hp_mobile;
        subItem.cid = equipment.cid;
        subItem.picto = translation['picto'][equipment.imageId];
        subItem.label = equipment.label;
        subItem.trackingName = equipment.label;
        subItem.detail = [];
        subItem.detailLong = [];
        if (Object.prototype.hasOwnProperty.call(equipment, 'detail')) {
            subItem.detail.push(equipment.detail);
            subItem.detailLong.push(equipment.detail);
        }
        if (equipment.cid && equipment.usageCode) {
            subItem.link = DashboardV7MapperUtils.getEquipmentPath(equipment.usageCode, equipment.usageType);
        }
        return subItem;
    }

    private static getWhoUsesIt(itemSection: ItemSection, translation: any): SubItemViewModel {
        return Object.assign(new SubItemViewModel(), {
            label: itemSection.whoUsesIt.label,
            cid: itemSection.cid,
            type: SubItemTypeEnum.picto,
            trackingArea: TmsCodes.care_hp_mobile,
            trackingName: itemSection.whoUsesIt.label,
            picto: translation['picto']['USER_UNKNOW'],
            link: Object.assign(new Link(), translation['whoUsesIt']['link']),
            linkParam: translation['whoUsesIt']['linkParam'],
        });
    }

    private static getService24(itemSection: ItemSection, translation: any): SubItemViewModel {
        return Object.assign(new SubItemViewModel(), {
            cid: itemSection.cid,
            type: SubItemTypeEnum.picto,
            picto: translation['picto']['SERVICE_24'],
            label: itemSection.service24.title,
            detailLong: [itemSection.service24.text],
            link: itemSection.service24.link,
            trackingArea: TmsCodes.care_hp_mobile,
            trackingName: TrackedName.SERVICE_24H,
        });
    }

    public static extractImage(itemSection: ItemSection): string {
        let image: string = DashboardV7MapperUtils.defaultMobileImage;
        if (itemSection.title && itemSection.title.imageUrl) {
            image = itemSection.title.imageUrl;
        } else {
            if (itemSection.usageCode) {
                switch (itemSection.usageCode) {
                    case UsageCodeEnum.CODE41001:
                        image = DashboardV7MapperUtils.defaultTabletImage;
                        break;
                    case UsageCodeEnum.CODE43001:
                        image = DashboardV7MapperUtils.defaultMultisimImage;
                        break;
                    case UsageCodeEnum.CODE44001:
                        image = DashboardV7MapperUtils.defaultMultisimImage;
                        break;
                    case UsageCodeEnum.CODE45001:
                        image = DashboardV7MapperUtils.airboxImage;
                        break;
                    default:
                        break;
                }
            }
        }
        return image;
    }
}
